export const SUBMISSION_STATUS_LABELS = {
  DRAFT: "Utkast",
  SUBMITTED: "Inskickad",
  APPROVED: "Godkänd",
  REJECTED: "Avvisad",
  IN_REVIEW: "Under granskning",
  IN_CLARIFY: "Behöver förtydligas",
  CLARIFIED: "Förtydligad"
};

export function getSubmissionStatusLabel(status) {
  return SUBMISSION_STATUS_LABELS[status] ?? status ?? "—";
}